import { AccountAccess } from "./AccountAccess";
import { Profile } from "./Profile";

export const ProviderProfile = () => {
  return (
    <div className="flex w-full flex-col items-center gap-6 px-6 pb-6 md:gap-8">
      <AccountAccess />
      <Profile />
    </div>
  );
};
